import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const DEV_RECAPTCHA_SITE_KEY = '6Lcfvh8rAAAAAOfGBFCkVOhjiBU0_JWz5Kipwo28';
const PROD_RECAPTCHA_SITE_KEY = '6Le42x8rAAAAAJPpoy2wlYgzEdOyNcXQgI1gwmOc';
/**
 * We'll set the App Check debug token to bypass App Check for local development,
 * dev preview channels, and dev chromatic builds.
 */
const setDebugToken = (isProd, generateDebugToken = false) => {
    const debugToken = isProd
        ? process.env.VUE_APP_APPCHECK_DEBUG_TOKEN_PROD
        : process.env.VUE_APP_APPCHECK_DEBUG_TOKEN_DEV;
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken !== null && debugToken !== void 0 ? debugToken : generateDebugToken;
};
/**
 * Initialize App Check for the given Firebase app. This gets initialized for
 * either the development or production firebase project based on the `isProd`
 * parameter. In addition, we can use a debug token to bypass the App Check
 * implementation for development purposes on non-whitelisted domains. Currently,
 * this is used for testing on storybook, the three apps, the GitLab preview
 * channels, and chromatic for both dev and prod staging. The preview channels
 * and non-latest chromatic versions do not support prod staging for security
 * reasons.
 * @param firebaseApp - The Firebase app to initialize App Check for.
 * @param isProd - Whether the app is using the production firebase project.
 */
const initAppCheck = (firebaseApp, isProd) => {
    const recaptchaSiteKey = isProd ? PROD_RECAPTCHA_SITE_KEY : DEV_RECAPTCHA_SITE_KEY;
    // Set the second argument to true to generate a new debug token
    setDebugToken(isProd);
    return initializeAppCheck(firebaseApp, {
        provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
    });
};

export { initAppCheck };
